














































































































import { editFactory } from '@/main/pages';
import { TabulkovaPozice } from '@/modules/ciselnik/dilenske/tabulkovaPozice';
import { openSelectList } from '@/main/router/routerPath';
import { apiProvider } from '@/modules/ciselnik/dilenske/servisniPakety/api';

import { DruhSP } from '../druhSP';
import { editMutations, editActions } from './store/types';
import { DEPENDENT_TABLES, NAME, SERVISNI_PAKETY_DRUH } from './constants';
import { store } from './store/edit';

export default editFactory(NAME, store).extend({
	components: {
		TabulkovaPoziceSelect: TabulkovaPozice.components.Select,
	},
	created() {
		if (!this.mainCollapse.length) {
			this.mainCollapse = ['ServisniPaketyDruh', 'ServisniPaketyNd', 'ServisniPaketyPp'];
		}
	},
	data() {
		return {
			dependencies: DEPENDENT_TABLES,
			items: {
				Druh: { id: 'Druh', labelKey: 'zalSNDRUH' },
				ND: { id: 'ND', labelKey: 'CAPaketND' },
				PP: { id: 'PP', labelKey: 'CAPaketPP' },
			},
		};
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				tabulkovaPozice: `${this.storeUri}/${editMutations.TABULKOVA_POZICE_SELECT_MAPPER_EDIT}`,
			};
		},
	},
	methods: {
		addDruhClick() {
			openSelectList(
				DruhSP.name,
				{
					filter: {
						Snzdrojdat: this.SnzdrojdatPzn,
						VyrobekvozOzn: this.VyrobekvozOzn,
					},
					afterRowSelection: ({ row }) => {
						this.$store.dispatch(`${this.storeUri}/${editActions.SERVISNI_PAKETY_DRUH}`, {
							snId: this.ZaznamId,
							snDruhId: row.ID,
						});
						this.refreshTable(SERVISNI_PAKETY_DRUH);
					},
					showFilter: false,
				},
			);
		},
		removeDruhClick(entity: any) {
			apiProvider.removeDruhSP(entity.data.ID);
			this.refreshTable(SERVISNI_PAKETY_DRUH);
		},
	},
});
